import Flex from "../../shared/components/Flex";
import Text from "../../shared/components/Text";

const GridLoading = () => {
    return (
        <Flex alignItems="center" justifyContent="center" height="100%" gap={10} flexDirection="column"
            style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#88888a",
                minHeight: "220px"
            }}
        >
            <Text size={16} weight={"semibold"}>Loading...</Text>
        </Flex>
    )
}

export default GridLoading;